<canvas #canvasScreenCapture id="canvas" style="display:none"></canvas>
<video autoplay #videoScreenCapture style="display:none"></video>
<img src="" #imgScreenCapture style="display:none" alt="imagen">
<a href="" #aScreenCapture style="display:none" aria-label="enlace"></a>
